import { render } from "./SmartSearchPage.vue?vue&type=template&id=d71c3fd8&ts=true"
import script from "./SmartSearchPage.vue?vue&type=script&lang=ts"
export * from "./SmartSearchPage.vue?vue&type=script&lang=ts"

import "./SmartSearchPage.vue?vue&type=style&index=0&id=d71c3fd8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__